/* eslint-disable */
import "bootstrap/dist/js/bootstrap.min";
import "jquery/dist/jquery.min";

// Font Awesome configuration
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { far } from "@fortawesome/free-regular-svg-icons";
import { fab } from "@fortawesome/free-brands-svg-icons";

// Add all icons to the library
library.add(fas, far, fab);

import React, { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import TagManager from "react-gtm-module";
import smoothscroll from "smoothscroll-polyfill";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import App from "./App";

import { AzureWrapper } from "./context-providers/AzureWrapper";
import { tagManagerConfig } from "./utils/TagManagerHelper";

import store from "./reducers/Store";

import "./styles/index.scss";

TagManager.initialize(tagManagerConfig);
smoothscroll.polyfill();

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <Provider store={store}>
    <AzureWrapper>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </AzureWrapper>
  </Provider>,
);
